var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"30px"}},[_c('Page',{attrs:{"total":_vm.paginations.total,"show-elevator":"","show-sizer":"","page-size":_vm.paginations.pageSize,"page-size-opts":_vm.paginations.pageSizeOpts,"current":_vm.paginations.current},on:{"on-change":_vm.changepage,"on-page-size-change":_vm.pageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }